module.exports = __webpack_public_path__ + "img/视频封面7.48ebc285.png";